import { ImportStatusEnum } from 'exports/interfaces/import-status.enum';
import { ImportTypeEnum } from './import-type.enum';

export interface ImportsMonitoringItem {
    id: string;
    channelName: string;
    channelLogoUrl: string;
    lastImportDateOutput: Date;
    successRate: number;
    partialSuccessRate: number;
    numberOfTotalItems: number;
    numberOfSuccessfulItems: number;
    numberOfPartialSuccessfulItems: number;
    numberOfFailedItems: number;
    adjustedSuccessPercentage?: number;
    adjustedPartialSuccessPercentage?: number;
    adjustedFailurePercentage?: number;
    group: boolean;
}
export interface ImportsMonitoringChannelDrilldownImport {
    id: string;
    listingName: string;
    listingId: string;
    supplierName: string;
    companyId: string;
    importDate: Date;
    status: ImportStatusEnum;
    importType: ImportTypeEnum;
    group: boolean;
    itemDetails: ImportsMonitoringListingImportItemDetails[];
}

export interface ProcessedImportsMonitoringItemDetails {
    featureGroupId: string;
    featureGroupName: string;
    isSuccessful: boolean;
    children: BaseImportChildItem[];
    failedChildren?: BaseImportChildItem[];
    extraFailedChildren?: number;
}

export interface ImportsMonitoringListingImportItemDetails {
    featureGroupId: string;
    featureGroupName: string;
    details: BaseImportChildItem[];
}

interface BaseImportChildItem {
    id: string;
    name: string;
    isSuccessful: boolean;
}

export enum MonitoringChannelDateRangesEnum {
    UNKNOWN = 'UNKNOWN',
    LAST_DAY = 'LAST_DAY',
    LAST_WEEK = 'LAST_WEEK',
    LAST_MONTH = 'LAST_MONTH',
}
